import { ArrowDown, ArrowUp, ArrowUpArrowDown } from "@gravity-ui/icons";
import { type IconData } from "@gravity-ui/uikit";
import { ProductControllerSearchSortByEnum } from "definitions/product-storage";

import { type SortState } from "../../../store/atoms";

interface ReleaseSortToggle {
  icon: IconData;
  isActive: boolean;
  nextSort: SortState | null;
}

export const getReleaseSortToggle = (
  sortType: ProductControllerSearchSortByEnum | undefined,
): ReleaseSortToggle => {
  if (sortType === ProductControllerSearchSortByEnum.ReleaseDesc) {
    return {
      icon: ArrowDown,
      isActive: true,
      nextSort: { type: ProductControllerSearchSortByEnum.ReleaseAsc },
    };
  }

  if (sortType === ProductControllerSearchSortByEnum.ReleaseAsc) {
    return { icon: ArrowUp, isActive: true, nextSort: null };
  }

  return {
    icon: ArrowUpArrowDown,
    isActive: false,
    nextSort: { type: ProductControllerSearchSortByEnum.ReleaseDesc },
  };
};
